import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingServicePaymentMethods } from '../../api/charging-service.ts';
import { UpdateChargingServicePaymentMethodsRequest } from '../../api/requests/charging-service-request.ts';

export default function useUpdateChargingServicePaymentMethods(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingServicePaymentMethods>>,
  Error,
  UpdateChargingServicePaymentMethodsRequest
> {
  return useMutation({
    mutationFn: updateChargingServicePaymentMethods,
  });
}
